<template>
  <div class="event-registration-box event-box-shadow">
    <div class="event-card-main-head">
      <div class="event-card-top-head">
        <!-- closed message-->
        <span v-if="registrationClosed" class="event-select-title">Registration closed</span>
        <!-- select ticket message -->
        <div v-else class="d-flex justify-content-between">
          <span class="event-select-title">{{ labels['ticket-label-selection'] }}</span>
          <span class="event-price-gst" v-if="item.PricingGstApplicable">{{ labels['ticket-label-gst'] }}</span>
        </div>
      </div><!-- /.event-card-top-head -->
      <div v-if="registrationClosed" class="p-4">
        <p>Registration for this event has closed.</p>
      </div>
      <template v-else>
      <ticket-option
        v-for="(option, index) in availableTickets"
        :item="option"
        :labels="labels"
        :key="index"
        :id="index"
        :conflictCode="conflictCode"
        :tickets="tickets"
        :registrationLockedCode="registrationLockedCode"
        :singleTicketOption="availableTickets.length === 1"
        @checked-registration-locked="registrationLockedCode = $event"
        @select-number-of-ticket="onSelectNumberOfTicket"
        @checked-conflict-code="onConflictCodeChecked" />
      </template>
    </div>
    <!-- /.event-card-main-head -->
    <div class="event-card-body flex flex-end">
      <div class="mb-3 px-4" v-if="!valid">
        <el-alert :title="labels['ticket-validation-noselection']" type="error" show-icon @close="valid = true"></el-alert>
      </div>
      <div class="mb-3 px-4" v-if="!isValidMaximumAttendess">
        <el-alert :title="labels['QtyExceededMessage'].replace('[MaximumAttendees]', item.MaximumAttendees)" type="error" show-icon @close="isValidMaximumAttendess = true"></el-alert>
      </div>
      <div v-if="!registrationClosed" class="event-btn d-flex flex-wrap flex-end ml-auto">
        <!-- <a :href="`${labels['donation-link']}?key=${item['PartyUnitID']}`" v-if="labels['donation-link']" class="ml-auto mr-3">
          <button type="button" class="order-0 btn btn-secondary">
              {{ labels['ticket-label-donation'] }}
          </button>
        </a> -->
        <button type="button" class="btn btn-primary ml-auto" @click="onNextClick">Next <i class="far fa-arrow-right ml-2"></i></button>

      </div>
    </div><!-- /.event-card-body -->
  </div>
</template>

<script>
import TicketOption from '../_FormElements/TicketOption.vue';

export default {
  components: {
    TicketOption
  },
  props: {
    item: { type: Object, required: true },
    labels: { type: Object, required: true },
    donationConfig: { type: [Object, Array], required: true },
    tickets: Array
  },
  data: function () {
    return {
      selectedTickets: [],
      conflictCode: '',
      registrationLockedCode: '',
      valid: true,
      isValidMaximumAttendess: true,
    }
  },
  mounted() {
    this.selectedTickets = [...this.tickets];
  },
  computed: {
    availableTickets: function () {
      const ticketOptions = this.item.PricingTicketOptions.filter(ticket => !ticket.soldOut);
      return ticketOptions;
    },
    registrationClosed() {
      // calculate if EventOnlineCutoff is in the past
      const eventOnlineCutoff = new Date(this.item.EventOnlineCutoff)
      const now = new Date()
      return eventOnlineCutoff < now
    }
  },
  methods: {
    onSelectNumberOfTicket: function (payload) {
      
      let conflictTicket = this.selectedTickets.filter((ticket) => {
          if(payload.conflictCode)
          {
            return ticket.conflictCode === payload.conflictCode;
          }
          
          if(payload.type == 'table' && ticket.code == payload.code)
          {
            return true
          }
          return false;
      });

      if(conflictTicket.length > 0)
      {
        this.selectedTickets = [];
      }else {
        this.selectedTickets = [ ...this.selectedTickets.filter(ticket => ticket.code !== payload.code) ];
      }

      if(this.labels['registration-locked'])
      {
        this.selectedTickets = [];
      }
      if (payload.value !== "0") {
        this.selectedTickets.push({
          code: payload.code,
          conflictCode: payload.conflictCode,
          name: payload.name,
          type: payload.type,
          price: payload.price,
          value: payload.value,
          total: Number.parseInt(payload.value, 10) * Number.parseInt(payload.price, 10),
        });
      }
    },
    onConflictCodeChecked: function (code) {
      this.conflictCode = code;
    },
    onNextClick: function () {
      this.valid = true;
      this.isValidMaximumAttendess = true;

      // const singleAllowed = this.item.PricingTicketOptions.findIndex(ticket => ticket.TicketQtyAllowed === 1 && !ticket.soldOut);
      // if (this.selectedTickets.length === 0 && singleAllowed > -1) {
      //   const singleTicket = this.item.PricingTicketOptions[singleAllowed];
      //   if (!singleTicket.TicketConflictCode) {
      //     this.selectedTickets = [{
      //       code: singleTicket.FunctionCode,
      //       name: singleTicket.TicketName,
      //       type: singleTicket.TicketType,
      //       price: singleTicket.TicketPrice,
      //       value: "1",
      //       total: Number.parseInt(singleTicket.TicketPrice, 10)
      //     }];
      //     this.valid = true;
      //   }
      // }

      if (this.selectedTickets.length === 0) {
        this.valid = false;
      }


      let MaximumAttendees = this.item["MaximumAttendees"];
      let individualTicketCount = 0;
      let hasIndividualTicket = false;
      
      if(MaximumAttendees && MaximumAttendees != '' && Number(MaximumAttendees) > 0)
      {
        this.selectedTickets.forEach(ticket => {
          if(ticket.type == "individual")
          {
            individualTicketCount += Number(ticket.value); // increment ticket count
            hasIndividualTicket = true;
          }
        });   

        if(hasIndividualTicket)
        {
            if(Number(individualTicketCount) > Number(MaximumAttendees))
            {
              this.isValidMaximumAttendess = false;
            }
        }
      }

      if (this.valid && this.isValidMaximumAttendess) {
        this.selectedTickets.sort((a, b) => {
            let typeA = a.type.toLowerCase(),
                typeB = b.type.toLowerCase();

            if (typeA < typeB) {
                return -1;
            }
            if (typeA > typeB) {
                return 1;
            }
            return 0;
        });

        this.$emit('next-step', { step: 2, tickets: this.selectedTickets });
      }
    }
  }
}
</script>
